import { useState } from "react";
import "./RowTabelaGerenciaPermissoes.css";
import { FaTrashAlt } from "react-icons/fa"; 

function DeleteModal({ tipo, origem, nome, onConfirm, onCancel }) {
  return (
    <div className="modal-overlay">
      <div className="delete-modal">
        <div className="lock-icon-container">
            <svg width="100" height="215" viewBox="0 0 100 215" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21.8631 71.9491H116.738V51.5324C116.738 43.0255 113.663 35.7946 107.514 29.8397C101.365 23.8848 93.8978 20.9074 85.1131 20.9074C76.3284 20.9074 68.8614 23.8848 62.7121 29.8397C56.5628 35.7946 53.4881 43.0255 53.4881 51.5324H32.4048C32.4048 37.4109 37.5438 25.3736 47.822 15.4204C58.1001 5.4673 70.5305 0.490738 85.1131 0.490738C99.6958 0.490738 112.126 5.4673 122.404 15.4204C132.682 25.3736 137.821 37.4109 137.821 51.5324V71.9491H148.363C154.161 71.9491 159.124 73.9482 163.253 77.9465C167.382 81.9447 169.446 86.7512 169.446 92.3657V194.449C169.446 200.064 167.382 204.87 163.253 208.868C159.124 212.867 154.161 214.866 148.363 214.866H21.8631C16.0652 214.866 11.1018 212.867 6.97301 208.868C2.8442 204.87 0 200.064 0 194.449V92.3657C0 86.7512 2.8442 81.9447 6.97301 77.9465C11.1018 73.9482 16.0652 71.9491 21.8631 71.9491Z" fill="rgba(69, 69, 69, 0.15)" />
                
                <circle cx="84" cy="145" r="21" fill="white" />
            </svg>

        </div>
        <div className="modal-header">
          <span className="modal-title">Atenção !</span>
        </div>

        <div className="modal-divider"></div>

        <div className="modal-content">
          <span className="modal-text">
            Realmente deseja deletar a permissão{" "}
            <span className="highlight"><b>{tipo}</b></span>{" "}
            {origem === "Departamento" ? "do setor " : "de "}
            <span className="highlight"><b>{nome}</b></span>?
          </span>
        </div>

        <div className="modal-divider"></div>

        <div className="modal-buttons">
          <button className="confirm-delete" onClick={onConfirm}>Sim</button>
          <button className="reject-delete" onClick={onCancel}>Não</button>
        </div>
      </div>
    </div>
  );
}

function RowTabelaGerenciaPermissoes({ codigo, nome, setor, origem, tipo, deletePermission }) {
  const [ showModal, setShowModal ] = useState(false);

  return (
    <>
      <tr>
        <td className="id-generico">{codigo}</td>
        <td className="origem">{origem}</td>
        <td className="nome">{nome}</td>
        <td className="setor">{setor}</td>
        <td className="tipo">{tipo}</td>
        <td className="acao">
          <button 
            className="deletar_btn" 
            onClick={() => setShowModal(true)}
          >
            <FaTrashAlt size={16} color="white" />
          </button>
        </td>
      </tr>

      {showModal && (
        <DeleteModal 
          tipo={tipo} 
          origem={origem} 
          nome={nome}
          onConfirm={() => {
            deletePermission();
            setShowModal(false);
          }}
          onCancel={() => setShowModal(false)}
        />
      )}
    </>
  );
}

export default RowTabelaGerenciaPermissoes;